import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 {...{
      "id": "what-if-i-have-feedback-on-this-destination"
    }}>{`What if I have feedback on this destination?`}</h3>
    <p>{`We love feature requests and feedback. Please `}<a parentName="p" {...{
        "href": "https://us.posthog.com/#panel=support%3Afeedback%3Aapps%3Alow%3Atrue"
      }}>{`tell us what you think`}</a>{`.`}</p>
    <h3 {...{
      "id": "what-if-my-question-isnt-answered-above"
    }}>{`What if my question isn't answered above?`}</h3>
    <p>{`We love answering questions. Ask us anything via `}<a parentName="p" {...{
        "href": "/questions"
      }}>{`our community forum`}</a>{`. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      